'use client';
import React, { useEffect, useRef } from 'react';
import MapDisplay from './MapDisplay';

export default function ContactSection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1 }
    );
    const els = sectionRef?.current?.querySelectorAll('.reveal, .reveal-left, .reveal-right');
    els?.forEach((el) => observer?.observe(el));
    return () => observer?.disconnect();
  }, []);

  return (
    <section id="contact" ref={sectionRef} className="relative bg-canopy blueprint-grid overflow-hidden py-24 md:py-32 px-6 md:px-10">
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none select-none overflow-hidden">
        <span className="font-mono font-black text-[15vw] text-chartreuse/[0.03] leading-none whitespace-nowrap">
          KONTAK
        </span>
      </div>
      <div className="max-w-7xl mx-auto relative z-10">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 border border-chartreuse/30 rounded-sm mb-8">
            <span className="w-2 h-2 rounded-full bg-chartreuse animate-pulse" />
            <span className="font-mono text-[10px] uppercase tracking-[0.35em] text-chartreuse">
              Siap Memulai? Hubungi Kami
            </span>
          </div>
          <h2 className="font-mono font-bold leading-tight text-text-primary mb-6"
            style={{ fontSize: 'clamp(2.5rem, 6vw, 5rem)' }}>
            Bergabung dengan<br />
            <span className="text-chartreuse">Kommunitas</span>
          </h2>
          <p className="text-text-muted text-xl max-w-2xl mx-auto mb-10 leading-relaxed">
            Bergabunglah dengan komunitas pengembang teknologi pertanian dan mulai
            transformasi pertanian Anda dengan IoT dan smart farming.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://wa.me/6281253837777?text=Halo%20Agro Teknologi Nusantara,%20saya%20tertarik%20dengan%20layanan%20smart%20farming"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-chartreuse px-10 py-5 rounded-sm text-base uppercase tracking-widest w-full sm:w-auto text-center"
            >
              Hubungi via WhatsApp →
            </a>
            <a
              href="/quote"
              className="btn-outline-chartreuse px-10 py-5 rounded-sm text-base uppercase tracking-widest w-full sm:w-auto text-center"
            >
              Kirim Pesan
            </a>
          </div>
          <div className="flex flex-wrap items-center justify-center gap-6 mt-10">
            {[
              'Respon 1x24 jam',
              'Konsultasi gratis',
              'Tim teknis berpengalaman',
              'Layanan di Kalimantan Timur',
            ].map((trust) => (
              <div key={trust} className="flex items-center gap-2">
                <span className="text-chartreuse font-mono text-xs">✓</span>
                <span className="font-mono text-xs text-text-muted tracking-wide">{trust}</span>
              </div>
            ))}
          </div>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start">
          <div className="reveal border border-chartreuse/20 rounded-sm overflow-hidden h-[400px] md:h-[450px] bg-pond/30">
            <MapDisplay />
          </div>
          <div className="reveal delay-200 flex flex-col gap-4">
            <div className="border border-chartreuse/20 rounded-sm p-6 bg-pond/40">
              <div className="annotation mb-3">ALAMAT KANTOR</div>
              <p className="text-text-muted text-sm leading-relaxed">
                Jl. Poros Samarinda Anggana, Sungai Meriam,<br />
                Kec. Anggana, Kabupaten Kutai Kartanegara,<br />
                Kalimantan Timur 75256
              </p>
              {/* <div className="mt-3 font-mono text-xs text-chartreuse/60">
                Koordinat: -0.5697° S, 117.2593° E
              </div> */}
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div className="border border-chartreuse/20 rounded-sm p-6 bg-pond/40">
                <div className="annotation mb-3">TELEPON</div>
                <a
                  href="https://wa.me/6281253837777"
                  className="font-mono text-text-primary text-lg hover:text-chartreuse transition-colors block"
                >
                  +62 812 5383 7777
                </a>
                <div className="font-mono text-[10px] text-text-muted/60 mt-1">WhatsApp tersedia</div>
              </div>
              <div className="border border-chartreuse/20 rounded-sm p-6 bg-pond/40">
                <div className="annotation mb-3">EMAIL</div>
                <a
                  href="mailto:ptagroteknologinusantara@gmail.com"
                  className="font-mono text-text-primary text-sm hover:text-chartreuse transition-colors break-all"
                >
                  ptagroteknologinusantara@<br />gmail.com
                </a>
                {/* <div className="font-mono text-[10px] text-text-muted/60 mt-1">Respon 1x24 jam</div> */}
              </div>
            </div>
            <div className="border border-chartreuse/20 rounded-sm p-6 bg-pond/40">
              <div className="annotation mb-3">MEDIA SOSIAL</div>
              <a
                href="https://instagram.com/agroteknologinusantara"
                target="_blank"
                rel="noopener noreferrer"
                className="font-mono text-chartreuse text-sm hover:underline"
              >
                @agroteknologinusantara
              </a>
              <div className="font-mono text-[10px] text-text-muted/60 mt-1">Instagram</div>
            </div>
            {/* <div className="border border-chartreuse/20 rounded-sm overflow-hidden h-40 relative">
              <AppImage
                src="/assets/images/greenhouse2.jpg"
                alt="Lokasi Agro Teknologi Nusantara di Kalimantan Timur"
                fill
                className="object-cover brightness-50" />
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="glass-card px-4 py-2 rounded-sm">
                  <span className="font-mono text-chartreuse text-xs">📍 Anggana, Kutai Kartanegara</span>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </section>
  );
}
